import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_LT.json';
import exercises from './PILATES_EXERCISES_LT.json';
import recipes from './PILATES_RECIPES_LT.json';

export const PILATES_DATA_LT: ServiceData = {
  articles,
  exercises,
  recipes,
};
